import axios from 'axios';
import { toast } from 'react-toastify';
import { LOGIN_SUCCESS, LOGIN_ERROR, IS_LOADING, SET_CURRENT_USER, LOGOUT_SUCCESS, CLEAR_STATE } from './Type';
import store from "../store";
import { apiHeader } from './ApiHeader';
import 'react-toastify/dist/ReactToastify.css';
import { baseUrlPostGres } from '../constant';
import HandleError from '../HandleError';
import { apiVersion } from 'src/utils/apiVersion';

toast.configure();

export const setCurrentUser = (token) => {
    return (
        store.dispatch({
            type: SET_CURRENT_USER,
            payload: token
        })
    )
}

export const clearState = () => ({
    type: CLEAR_STATE
});

export const clearStateThunk = () => {
    return (dispatch) => {
        // Perform any asynchronous operations here if needed
        dispatch(clearState());
    };
};

export const LoginAction = (formData) => (dispatch) => {

    dispatch({ type: IS_LOADING })
    axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/vendor/login`, formData, {
            headers: apiHeader(true)
        })
        .then(response => {
            const res = response.data.data.user
            console.log("response.data.data===>>", res?.usertype)
            const payload = {
                id: res.id,
                logintype: res.logintype,
                email: res.email,
                country_code: res.country_code,
                phone: res.phone,
                token: res.token,
                status: res.status,
                name: res.profilename,
                profile_img: res.profilepic,
                setting: response.data.data.gameSettingsList
            }

            let chkMaster = (res.apikey === "master") ? "master" : "";
            localStorage.setItem("security_auth", JSON.stringify(payload));
            localStorage.setItem("is_master", chkMaster);
            localStorage.setItem("usertype", res?.usertype);
            dispatch({ type: LOGIN_SUCCESS, payload: response })
            dispatch(setCurrentUser(payload))

            //return;

            toast.success(response.data.message, { theme: "colored" })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            toast.error(errors.response.data.message, { theme: "colored" })
            dispatch({
                type: LOGIN_ERROR,
                payload: errors.response.data
            })
        })
}

export const LogoutAction = () => (dispatch) => {
    dispatch({ type: IS_LOADING })
    axios
        .get(`${baseUrlPostGres()}/admin/${apiVersion.v1}/users/logout`, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({ type: LOGOUT_SUCCESS, payload: response })
            dispatch(setCurrentUser({}))
            dispatch(clearStateThunk());
            toast.success(response.data.message, { theme: "colored" })
            localStorage.removeItem("security_auth");
        })
        .catch(error => {
            HandleError(error.response.data)
            console.log("logout error", error);
        })
}